import { combineReducers } from 'redux';

import {
  SET_REASON_FILTERS,
  RESET_REASON_FILTERS,
  SET_REASON_GRID_SORT_CRITERIA,
} from './actionTypes';

const reasonFiltersInitialState = {
  aggregatorID: '',
  payerID: '',
};

const reasonGridSortCriteriaInitialState = {
  sortByColumn: '',
  sortDirection: '',
};

const reasonFiltersReducer = (
  state = reasonFiltersInitialState,
  { type = '', filters = { ...reasonFiltersInitialState } } = {},
) => {
  switch (type) {
    case SET_REASON_FILTERS:
      return {
        ...state,
        ...filters,
      };

    case RESET_REASON_FILTERS:
      return {
        ...state,
        ...reasonFiltersInitialState,
      };

    default: {
      return state;
    }
  }
};

const currentReasonGridSortCriteriaReducer = (
  state = reasonGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...reasonGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_REASON_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const reasonReducer = combineReducers({
  reasonFilters: reasonFiltersReducer,
  reasonGridSortCriteria: currentReasonGridSortCriteriaReducer,
});

export { reasonReducer, reasonFiltersInitialState, reasonGridSortCriteriaInitialState };
